/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Resource service
 *
 * @file ResourceService.js
 * @author JP
 * @since 1.0.0
 */

import BaseService from './BaseService';
import Clients from '../config/Clients';
import StoreRegistry from '../common/StoreRegistry';
import ResourceUtils from '../utils/ResourceUtils';
import { RESOURCE_REQUESTED, USER_ROLE_STUDENT, USER_ROLE_INSTRUCTOR } from '../common/constants';

export default class ResourceService extends BaseService {
  constructor() {
    super(RESOURCE_REQUESTED);

    this.stores = StoreRegistry.getStores();
    this.resourceApi = new Clients().resourceApi();
  }

  /**
   * Handle the event according to the event type
   *
   * @param {*} eventName
   * @param {*} event
   */
  handleEvent(eventName, event) {
    const { type } = event;
    const {
      resources: {
        isFetched,
        isNetworkError
      }
    } = this.stores;

    switch (type) {
      case 'GET':
        if (!isFetched || isNetworkError) {
          this.handleGet(event);
        }
        break;
      default:
        break;
    }
  }

  /**
   * Handle GET calls
   *
   * @param {*} event
   */
  handleGet = (event) => {
    const {
      bookId,
      userRole
    } = event;
    const {
      resources: {
        setIsFetched, // TODO: setIsFetched to be renamed
        setIsNetworkError,
        setStructuredResourcesData,
        setUserRoleTab,
        setShowTeacherTab,
        setShowStudentTab
      }
    } = this.stores;

    this.resourceApi.get(`/${bookId}/resource`)
      .then(
        (response) => {
          if (response.data) {
            setIsNetworkError(false);
            const flatResources = ResourceUtils.constructFlatResource(response.data);
            const showTeacherTab = flatResources.some(resource => resource.limitByRoles && resource.limitByRoles.includes(USER_ROLE_INSTRUCTOR));
            const showStudentTab = flatResources.some(resource => resource.limitByRoles && resource.limitByRoles.includes(USER_ROLE_STUDENT));
            setShowTeacherTab(showTeacherTab);
            setShowStudentTab(showStudentTab);
            if (ResourceUtils.isStudentRoleTab(showTeacherTab, showStudentTab, userRole)) {
              setUserRoleTab(USER_ROLE_STUDENT);
            }
            setStructuredResourcesData(response.data);
          }
        }, // eslint-disable-next-line no-unused-vars
        (error) => {
          setIsFetched(true); // TODO: setIsFetched to be renamed
          setIsNetworkError(true);
        }
      );
  };
}
